import { render } from "./SiteDetailView.vue?vue&type=template&id=5397b6e1&scoped=true"
import script from "./SiteDetailView.vue?vue&type=script&lang=js"
export * from "./SiteDetailView.vue?vue&type=script&lang=js"

import "./SiteDetailView.vue?vue&type=style&index=0&id=5397b6e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5397b6e1"]])

export default __exports__